import { BaseAddressPage, IAddressPageBaseProps } from './baseAddressPage'
import { useFormContext } from 'react-hook-form'
import tzLookup from '@photostructure/tz-lookup'

interface IFormAddressPageProps
    extends Omit<IAddressPageBaseProps, 'onSave' | 'value'> {
    fieldName: string
}
export const FormAddressPage = (props: IFormAddressPageProps) => {
    const { watch, setValue } = useFormContext()
    const { fieldName, ...restProps } = props
    return (
        <BaseAddressPage
            {...restProps}
            onSave={(val) => {
                if (val) {
                    const tz = tzLookup(
                        Number.parseFloat(val.lat ?? '0'),
                        Number.parseFloat(val.lon ?? '0')
                    )
                    val.timeZone = tz
                }
                setValue(fieldName, val, {
                    shouldDirty: true,
                    shouldTouch: true,
                })
            }}
            value={watch(fieldName)}
        />
    )
}
